import { render } from "./monthNavigator.vue?vue&type=template&id=6988c032&ts=true"
import script from "./monthNavigator.vue?vue&type=script&lang=ts"
export * from "./monthNavigator.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__